import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { userId: Number };
  static targets = ["chip"];

  chipTargetConnected(element) {
    if (Number(element.dataset.userId) === this.userIdValue) {
      element.remove();
    } else {
      element.classList.remove("hidden");
    }
  }
}
